<template>
  <div class="w-full" :class="{ 'animation-wrapper': naanAmountEqual4 }">
    <div class="text-center font-bold text-6xl px-10">
      <span :class="{ 'text-white': naanAmountEqual4 }">
        {{ naanAmount }} naan?
      </span>
    </div>
    <div class="text-center font-medium text-2xl px-10">
      <span :class="{ 'text-white': naanAmountEqual4 }">
        Are you sure
      </span>
    </div>
    <insane-animation-component v-if="naanAmountEqual4" />
    <transition-group name="slide-fade1" appear>
      <div :key="1" class="w-full max-display-card">
        <div class="w-full px-8 md:px-20 lg:px-20 py-6">
          <div class="w-full flex flex-col">
            <div class="w-full flex justify-center">
              <button
                @click="$emit('confirmNaanAmount')"
                class="w-button-l bg-white rounded-lg my-1 mx-1 py-2 px-4 md:px-8 lg:px-8 font-medium text-regal-gray"
                :class="{ 'shadow-white__button': naanAmountEqual4 }"
              >
                Calculate what you actually need
              </button>
            </div>
          </div>
        </div>
      </div>
      <div :key="2" class="w-full max-display flex justify-center">
        <naan-svg-component
          :naan-amount="naanAmount"
          class="overflow-x-hidden"
          :class="{ 'img-animation': naanAmountEqual4 }"
        />
      </div>
    </transition-group>
    <x-footer :text-color="changeFooterColor" />
  </div>
</template>
<script>
import XFooter from "@/components/Footer/XFooter";
import InsaneAnimationComponent from "@/components/ScreenComponents/InsaneAnimationComponent";
import NaanSvgComponent from "@/components/ScreenComponents/NaanSvgComponent";

export default {
  name: "AmountConfirmationComponent",
  components: {
    NaanSvgComponent,
    InsaneAnimationComponent,
    XFooter
  },
  props: {
    naanAmount: {
      type: Number
    },
    changeFooterColor: {
      type: Boolean
    }
  },
  computed: {
    naanAmountEqual4() {
      return this.naanAmount === 4;
    }
  }
};
</script>
<style scoped>
button.shadow-white__button {
  box-shadow: 0 0 4px 0 rgba(255, 255, 255, 1);
}
button.shadow-white__button:hover {
  box-shadow: 0 0 10px 0 rgba(255, 255, 255, 1);
}

.animation-wrapper {
  animation: shake 0.5s;
  animation-iteration-count: 4;
}

.img-animation {
  animation: scale-img 5s;
}

@keyframes scale-img {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.4);
  }
  40%,
  100% {
    transform: scale(1);
  }
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
</style>
